module.exports = __webpack_public_path__ + "img/building.8f9b9ac1.svg";